
export default
	props:
		label:
			type: String
			required: true

		size:
			type: String
			default: 'normal'
			validator: (val) -> val in ['small', 'normal']

	computed:
		classes: -> ["size-#{@size}"]

